import {
  AutomationInputFileConfigSpec,
  AutomationOutputFileConfigSpec,
  ClientAutomationOutputFileConfigSpec,
} from 'lab-automation/settings/RunSchemaSpecConstants';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {RequestTemplateSpec} from 'requests/templates/RequestTemplateConstants';
import {ASSAY_SCHEMA_TYPE_NAMES, ASSAY_TYPES} from 'results/assay-schemas/AssaySchemaConstants';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import {schemaFieldsetName} from 'schemas/schema-interface/util/schemaFieldsetName';
import {capwords} from 'util/NameUtil';

enum NonAssaySchemaType {
  REQUEST_TASK = 'REQUEST_TASK',
  PROCESS = 'PROCESS',
  ENTITY = 'ENTITY',
  BOX = 'BOX',
  PLATE = 'PLATE',
  LOCATION = 'LOCATION',
  CONNECTION = 'CONNECTION',
  SCHEMA_INTERFACE = 'SCHEMA_INTERFACE',
  STUDY = 'STUDY',
}

export type SchemaType = NonAssaySchemaType | ASSAY_TYPES;

export const SCHEMA_TYPES = {
  ...ASSAY_TYPES,
  ...NonAssaySchemaType,
};

export const SCHEMA_TYPE_NAMES = {
  ...ASSAY_SCHEMA_TYPE_NAMES,
  REQUEST_TASK: 'Task',
  PROCESS: 'Task',
  ENTITY: 'Entity',
  BOX: 'Box',
  PLATE: 'Plate',
  LOCATION: 'Location',
  CONNECTION: 'Connection',
  SCHEMA_INTERFACE: capwords(schemaFieldsetName()),
  STUDY: 'Study',
};

export interface AssaySchemaSpec {
  fields: Array<SchemaField | ClientSchemaField>;
}

export interface RequestSchemaSpec extends AssaySchemaSpec {
  idPrefix: string;
  samplesSchema: Array<SchemaField | ClientSchemaField>;
  taskSchemas: Array<string>;
}

export interface RunSchemaSpec extends AssaySchemaSpec {
  automationInputFileConfigs?: Array<AutomationInputFileConfigSpec> | null;
  automationOutputFileConfigs?: Array<AutomationOutputFileConfigSpec> | null;
  allowInsertRunFromInbox: boolean;
  allowCreateRunFromNotebook: boolean;
  shouldRecordEquipment: boolean;
  connectionSchemaId?: string | null;
}

export interface ClientRunSchemaSpec extends AssaySchemaSpec {
  automationInputFileConfigs?: Array<AutomationInputFileConfigSpec> | null;
  automationOutputFileConfigs?: Array<ClientAutomationOutputFileConfigSpec> | null;
}

interface ConnectionSchemaSpec {
  fields: Array<ClientSchemaField>;
  idPrefix: string;
}

interface SchemaInterfaceSpec {
  fields: Array<ClientSchemaField>;
}

export type SchemaSpec =
  | AssaySchemaSpec
  | RunSchemaSpec
  | RequestSchemaSpec
  | RequestTemplateSpec
  | ConnectionSchemaSpec
  | SchemaInterfaceSpec;

export type ClientSchemaSpec =
  | AssaySchemaSpec
  | ClientRunSchemaSpec
  | RequestSchemaSpec
  | RequestTemplateSpec;
